import { useAuth } from './auth-context.ts'

/**
 * A loja ficou com o balcão de antes das F360–F366 (29/10)? Só a 4Play:
 * "a 4Play tem que ficar igual e o resto mudar". A chave `balcao-anterior`
 * é ligada pela Plataforma.
 *
 * Fora do `AuthProvider` (um diálogo testado sozinho) responde que não: é o
 * comportamento novo, o de toda loja menos uma.
 */
export const useBalcaoAnterior = (): boolean => {
  try {
    // Chamado sempre, e uma vez só: o `try` só segura o erro de fora do
    // provedor, não muda a ordem dos hooks.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const auth: Partial<ReturnType<typeof useAuth>> = useAuth()
    return auth.hasFeature?.('balcao-anterior') ?? false
  } catch {
    return false
  }
}
